import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CommunicationLimitService } from './communication-limits.service';
import { CommunicationLimitsToServer } from './communication-limits.interface';
const service = new CommunicationLimitService();

export interface CommunicationLimitState {}

const CommunicationExceptionStore: Module<CommunicationLimitState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async get() {
         return (await service.getCommunicationLimits()).data;
      },

      async create(context, limits: CommunicationLimitsToServer) {
         return (await service.postCommunicationLimit(limits)).data;
      },
   },
};

export default CommunicationExceptionStore;
